import React from "react";
import { createRoot } from "react-dom/client";
import "maplibre-gl/dist/maplibre-gl.css";
import App from "./App.jsx";
import "./styles.css";

createRoot(document.querySelector("#root")).render(
  React.createElement(App)
);
